"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _RankedNode = _interopRequireDefault(require("./RankedNode"));

var _RankedListSearch = _interopRequireDefault(require("./RankedListSearch"));

var RankedList = /*#__PURE__*/function () {
  function RankedList() {
    (0, _classCallCheck2["default"])(this, RankedList);
    this.head = null;
    this.tail = null;
    this.search = new _RankedListSearch["default"]();
  }

  (0, _createClass2["default"])(RankedList, [{
    key: "reset",
    value: function reset() {
      this.head = null;
      this.tail = null;
    }
  }, {
    key: "append",
    value: function append(value) {
      var newNode = new _RankedNode["default"](value);

      if (this.head) {
        this.tail.next = newNode;
        newNode.previous = this.tail;
        this.tail = newNode;
      } else {
        this.head = newNode;
        this.tail = newNode;
      }
    }
  }, {
    key: "undo",
    value: function undo() {
      if (this.tail && this.tail.previous) {
        this.tail = this.tail.previous;
        this.tail.next = null;
      } else {
        this.reset();
      }
    }
  }, {
    key: "find",
    value: function find(fieldValue) {
      var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentNode = this.head;
      var order = 1;
      var searchNode = null;

      while (currentNode) {
        var nodeFieldValue = currentNode.value.fieldValue;

        if (this.search.isEqual(fieldValue, nodeFieldValue)) {
          searchNode = {
            order: order,
            fieldKey: fieldValue,
            fieldValue: fieldValue
          };
          break;
        }

        currentNode = currentNode.next;
        order += 1;
      }

      if (searchNode && property) {
        return searchNode[property];
      }

      return searchNode;
    }
  }, {
    key: "values",
    value: function values() {
      var rankArray = [];
      var currentNode = this.head;

      while (currentNode) {
        rankArray.push(currentNode.value.fieldValue);
        currentNode = currentNode.next;
      }

      return rankArray;
    }
  }]);
  return RankedList;
}();

var _default = RankedList;
exports["default"] = _default;